import React, {useState} from 'react';
import './home.css';

function Home(){

    return(
        <section id="home-section">
            <div className="home-content">
                <h1>Nicolas DE SAINT JEAN</h1>
                <span>Développeur full-stack TypeScript</span>
            </div>
        </section>
    );
}

export default Home;